import React from "react";

function ConfirmPayment() {
  return <div>ConfirmPayment</div>;
}

export default ConfirmPayment;
